import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.store'
import global from './modules/global.store';
import assets from './modules/asset.store';
import events from './modules/event.store';
import geo from './modules/geo.store';
import traffic from './modules/traffic.store';
import customFields from './modules/customFields.store';
import hardData from './modules/hardData.store';

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user,
    global,
    assets,
    events,
    geo,
    customFields,
    hardData,
    traffic
  }
})
